import { useEffect, useState } from "react";
import {
  createLabelQuery,
  getAllLabelsQuery,
  removeLabelQuery,
  updateLabelQuery
} from "@query";
import { LabelGroups, MAX_LABEL_LENGTH } from "@utils";
import { useWorkspaceWebsocket } from "@hooks";
import { LabelEditor } from "@components";
import { Grid, CircularProgress } from "@material-ui/core";

export const Labels = () => {
  const socket = useWorkspaceWebsocket();

  const [isLoading, setLoading] = useState(true);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    (async () => {
      let t = await getAllLabelsQuery(LabelGroups.LABELS);
      setLabels(t);
      setLoading(false);
    })();
  }, []);
  
  const handleCreate = async (name, backgroundColor, fontColor) => {
    const id = await createLabelQuery(name, backgroundColor, fontColor, LabelGroups.LABELS)
    socket?.requestLabelCreate({id,  name, fontColor, backgroundColor, group: LabelGroups.LABELS });
    return id;
  }
  
  const handleRemove = async (id) => {
    await removeLabelQuery(id);
    socket?.requestLabelRemove(id);
  }
  
  const handleUpdate = async (id, name, backgroundColor, fontColor) => {
    await updateLabelQuery(id, name, backgroundColor, fontColor);
    socket?.requestLabelUpdate(id, { id, name, fontColor, backgroundColor });
  }

  if(isLoading)
    return <Grid
      item container
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress size={24} />
    </Grid>

  return (
    <LabelEditor
      labelList={labels}
      onCreate={handleCreate}
      onRemove={handleRemove}
      onUpdate={handleUpdate}
      maxLength={MAX_LABEL_LENGTH}
    />
  );
};